/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { enterpriseAuthnRule } from '../models/enterpriseAuthnRule';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EnterpriseAuthnRulesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count enterpriseAuthnRules
   * Count enterpriseAuthnRules (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of enterpriseAuthnRule documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServicesecurityEnterpriseAuthnRulesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/enterpriseAuthnRules/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one enterpriseAuthnRule
   * Find one enterpriseAuthnRule by its unique identifier.
   * @param identifier enterpriseAuthnRule unique identifier
   * @returns any One enterpriseAuthnRule document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServicesecurityEnterpriseAuthnRules(
    identifier: string,
  ): CancelablePromise<{
    data?: enterpriseAuthnRule;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/enterpriseAuthnRules/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one enterpriseAuthnRule which exists or not
   * Replace one enterpriseAuthnRule which exists or not
   * @param identifier enterpriseAuthnRule unique identifier
   * @param requestBody
   * @returns any enterpriseAuthnRule replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServicesecurityEnterpriseAuthnRules(
    identifier: string,
    requestBody?: enterpriseAuthnRule,
  ): CancelablePromise<{
    data?: enterpriseAuthnRule;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/servicesecurity/enterpriseAuthnRules/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing enterpriseAuthnRule
   * Partially update one existing enterpriseAuthnRule
   * @param identifier enterpriseAuthnRule unique identifier
   * @param requestBody
   * @returns any updated enterpriseAuthnRule. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityEnterpriseAuthnRules(
    identifier: string,
    requestBody?: enterpriseAuthnRule,
  ): CancelablePromise<{
    data?: enterpriseAuthnRule;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/enterpriseAuthnRules/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one enterpriseAuthnRule
   * Delete one enterpriseAuthnRule
   * @param identifier enterpriseAuthnRule unique identifier
   * @returns any delete status enterpriseAuthnRules. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServicesecurityEnterpriseAuthnRules(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/enterpriseAuthnRules/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many enterpriseAuthnRules
   * Find many enterpriseAuthnRules (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many enterpriseAuthnRule documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServicesecurityEnterpriseAuthnRules1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<enterpriseAuthnRule>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/enterpriseAuthnRules',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple enterpriseAuthnRules
   * Create one or multiple enterpriseAuthnRules
   * @param requestBody
   * @returns any One or many enterpriseAuthnRule documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServicesecurityEnterpriseAuthnRules(
    requestBody?: (enterpriseAuthnRule | Array<enterpriseAuthnRule>),
  ): CancelablePromise<{
    data?: (enterpriseAuthnRule | Array<enterpriseAuthnRule>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/enterpriseAuthnRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many enterpriseAuthnRules which exists or not
   * Replace many enterpriseAuthnRules which exists or not
   * @param requestBody
   * @returns any enterpriseAuthnRules replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServicesecurityEnterpriseAuthnRules1(
    requestBody?: Array<enterpriseAuthnRule>,
  ): CancelablePromise<{
    data?: Array<enterpriseAuthnRule>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/servicesecurity/enterpriseAuthnRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing enterpriseAuthnRule
   * Partially update many existing enterpriseAuthnRule
   * @param requestBody
   * @returns any enterpriseAuthnRules updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityEnterpriseAuthnRules1(
    requestBody?: Array<enterpriseAuthnRule>,
  ): CancelablePromise<{
    data?: Array<enterpriseAuthnRule>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/enterpriseAuthnRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many enterpriseAuthnRules
   * Delete many enterpriseAuthnRules using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status enterpriseAuthnRules. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServicesecurityEnterpriseAuthnRules1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/enterpriseAuthnRules',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
